module.exports = __webpack_public_path__ + "img/contact-cover.31b4d5fb.png";